<template>
  <div>
    <b-row class="mb-1" :style="{ marginTop: canCreatePaquetes ? '-30px' : '0px' }">
      <div class="col-12 d-flex justify-content-end">
        <b-button
          v-if="canCreatePaquetes"
          variant="success"
          @click="modalCrear = true"
        >
          Crear paquete
        </b-button>
      </div>
    </b-row>
    <FilterPaquetes ref="filter" @filter-change="onFilterChange" @buscar="buscar" />
    <b-overlay :show="mostrarLoader" opacity="0.35" rounded="sm">
      <b-card>
        <div v-if="showButtonReportes" class="d-flex justify-content-end align-items-center mb-1">
          <h5 class="mr-1">Reporte:</h5>
          <b-button :disabled="descargandoBase" variant="outline-secondary" @click="descargarExcel" title="Descargar base">
            <b-spinner small type="grow" v-if="descargandoBase" class="mr-1" />
            <i class="fas fa-file-excel"></i>
          </b-button>
        </div>
        <h5 class="text-right my-1">Resultados: {{ table.totalRows }}</h5>

        <b-table
          v-if="items.length && !loadingTable"
          bordered striped responsive small
          :per-page="table.perPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
        >
          <template #cell(nombre)="{ item }">
            <div class="truncate" :title="item.nombre">{{ item.nombre || '-' }}</div>
          </template>

          <template #cell(precio)="{ item }">
            <div class="text-center">{{ formatCurrency(item.precio) }}</div>
          </template>

          <template #cell(tipoPaquete)="{ item }">
            <div class="text-center">{{ tipoLabel(item.tipoPaquete) }}</div>
          </template>

          <template #cell(vigencia)="{ item }">
            <div class="text-center">{{ item.vigencia || '-' }}</div>
          </template>

          <template #cell(estado)="{ item }">
            <div class="text-center">
              <b-badge :variant="item.estado === 'Activo' ? 'success' : 'danger'" pill>
                {{ item.estado === 'Activo' ? 'Activo' : 'Inactivo' }}
              </b-badge>
            </div>
          </template>

          <template #cell(acciones)="{ item }">
            <div class="d-flex justify-content-end">
              <b-button variant="warning" size="sm" class="mr-1" title="Editar" @click="editarPaquete(item)">
                <i class="fa-solid fa-user-pen" style="color: white;" />
              </b-button>
              <b-button variant="info" size="sm" class="mr-1" title="Ver" @click="abrirModalVer(item)">
                <i class="fa-solid fa-magnifying-glass" />
              </b-button>
              <b-button variant="danger" size="sm" title="Eliminar" @click="eliminarPaquete(item)">
                <i class="fa-solid fa-circle-xmark" style="color: white;" />
              </b-button>
            </div>
          </template>
        </b-table>

        <div v-if="loadingTable">
          <b-skeleton-table :rows="12" :columns="10" :table-props="{ bordered: true, striped: true }" />
        </div>
        <div v-if="!items.length && !loadingTable" class="text-center">Sin registros</div>

        <b-col cols="12" class="mt-2">
          <b-pagination
            v-if="items.length"
            v-model="table.currentPage"
            :total-rows="table.totalRows"
            :per-page="table.perPage"
            :small="true"
            first-number
            align="center"
            @change="cambiarPagina"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>

        <!-- Modal Ver Paquete -->
        <b-modal id="modal-ver-paquete" v-model="modalVer" title="Paquete preventivo" size="xl" hide-footer>
          <PaqVistaPrevia
            v-if="previewData"
            :nombre="previewData.nombre"
            :precio="previewData.precio"
            :imagen-src="fullUrl(previewData.portada_url)"
            :descripcion="previewData.descripcion"
            :categorias="previewData.servicios || {}"
            :labels-categorias="labelsCategorias"
            :beneficios="(previewData.reglas && previewData.reglas.beneficios) || {}"
            :notas-paciente="(previewData.reglas && previewData.reglas.generales && previewData.reglas.generales.notasPaciente) || previewData.notas || ''"
          />
        </b-modal>

        <!-- Modal Crear Paquete -->
        <b-modal id="modal-crear-paquete" v-model="modalCrear" title="Crear paquete preventivo" size="xl" hide-footer no-close-on-backdrop>
          <CrearPaquete :embedded="true" @saved="onSaved()" />
        </b-modal>

        <!-- Modal Editar Paquete -->
        <b-modal id="modal-editar-paquete" v-model="modalEditar" title="Editar paquete preventivo" size="xl" hide-footer no-close-on-backdrop>
          <CrearPaquete :embedded="true" :edit-token="tokenEdit" :edit-id-prop="idEdit" :prefill-data="editJson" @saved="onSaved(true)" />
        </b-modal>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import { BootstrapVue } from 'bootstrap-vue'
import axios from 'axios'
import { FilterPaquetes } from '../components'
import actions from '@/assets/utils/utils'
import rutas from '@/assets/utils/rutas.json'
import { comprobarPermisos, comprobarRoles, getEstablecimientoLS, getIdDoctorLS } from '@/shared/helpers'
import { ROLES } from '@/shared/constants'
import { paquetesService } from '../services'
import PaqVistaPrevia from '../components/PaqVistaPrevia.vue'
import CrearPaquete from './CrearPaquete.vue'

export default {
  name: 'ConsultarPaquetes',
  components: { ...BootstrapVue.components, FilterPaquetes, PaqVistaPrevia, CrearPaquete },
  data(){
    return {
      mostrarLoader: false,
      descargandoBase: false,
      loadingTable: true,
      items: [],
      filters: {},
      table: { currentPage: 1, perPage: 15, totalRows: 0 },
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      urlView: null,
      modalVer: false,
      modalCrear: false,
      modalEditar: false,
      tokenEdit: null,
      idEdit: null,
      editJson: null,
      previewData: null,
      labelsCategorias: {
        laboratorio: 'Laboratorios',
        imagenes: 'Imágenes',
        procedimientos: 'Procedimientos',
        terapias: 'Terapias',
        atencion_medica: 'Atenciones',
      },
    }
  },
  created(){
    comprobarPermisos(this.$route)
    this.setToken()
    this.loadFiltersLS()
    this.getDataTable()
  },
  mounted(){
    // Título en header (si usas helper)
    if(actions?.setearTitulo) actions.setearTitulo('Paquetes Preventivos')
  },
  computed: {
    fields(){
      const base = [
        { key: 'codigo', label: 'Código', sortable: true, thClass: 'text-center', tdClass: 'text-center codigo-col', thStyle: { width: '15ch' }, tdStyle: { width: '15ch', maxWidth: '15ch', whiteSpace: 'nowrap' } },
        { key: 'nombre', label: 'Nombre', sortable: true, thClass: 'text-center', tdClass: 'nombre-col' },
        { key: 'precio', label: 'Precio', sortable: true, thClass: 'text-center' },
        { key: 'tipoPaquete', label: 'Tipo', sortable: true, thClass: 'text-center' },
        { key: 'fechaCreacion', label: 'Fecha', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
        { key: 'vigencia', label: 'Vigencia', sortable: true, thClass: 'text-center' },
        { key: 'estado', label: 'Estado', sortable: true, thClass: 'text-center' },
        { key: 'acciones', label: 'Acciones', sortable: false, thClass: 'text-center', tdClass: 'text-right' },
      ]
      return base
    },
    canCreatePaquetes() {
      // perm de ejemplo para crear paquetes preventivos
      return comprobarRoles([ROLES.JEFE_MEDICO])
    },
    showButtonReportes(){
      return comprobarRoles([ROLES.JEFE_MEDICO, ROLES.ESTADISTICAS, ROLES.JEFE_AUDITOR, ROLES.AUDITOR, ROLES.DIGITADOR])
    }
  },
  methods: {
    fullUrl(u){
      if (!u) return ''
      const s = String(u)
      if (/^(https?:)?\/\//.test(s) || s.startsWith('blob:')) return s
      return `${rutas.axios}file/show${s}`
    },
    setToken(){
      const user = JSON.parse(localStorage.getItem('usuario'))
      if(user?.token){
        axios.defaults.headers.common.Authorization = `JWT ${user.token}`
      }
    },
    hasPermission(permission) {
      const permisosUsuario = localStorage.getItem('permisos') || '';
      return permisosUsuario.indexOf(permission) !== -1;
    },
    redirectToCrearPaquete() {
      this.$router.push({ name: 'crear_paquete' }).catch(() => {});
    },
    loadFiltersLS(){
      const ls = localStorage.getItem('filterPaquetesPrev')
      if(ls){ try{ this.filters = JSON.parse(ls) } catch(e){} }
    },
    onFilterChange(f){ this.filters = { ...f } },
    async buscar(){
      this.table.currentPage = 1
      await this.getDataTable()
    },
    async cambiarPagina(pag){
      this.table.currentPage = pag
      await this.getDataTable()
    },
    async descargarExcel(){
      this.descargandoBase = true
      try{
        const tipoMap = { BASICO: '1', INTERMEDIO: '2', FULL: '3' }
        const establecimientoUser = getEstablecimientoLS()
        const idDoctor = getIdDoctorLS()
        // Para ahora, siempre enviamos doctor vacío si el usuario tiene rol de reporte
        const viewAll = this.showButtonReportes
        const params = {
          search: this.filters.search || '',
          establecimiento: establecimientoUser?.id || '0',
          doctor: viewAll ? '' : idDoctor,
          estado: this.filters.estado || '',
          tipoPaquete: tipoMap[this.filters.tipoPaquete] || '',
          fechaDesde: this.filters.fechaDesde || null,
          fechaHasta: this.filters.fechaHasta || null,
        }

        const resp = await paquetesService.getReportePaquetes(params)
        const base64 = resp?.dataarchivo
        if (base64) {
          actions.cargarArchivos(
            base64,
            'paquetes_preventivos.xlsx',
            'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64'
          )
        } else {
          const msg = resp?.message || 'No se pudo generar el archivo.'
          this.$bvToast && this.$bvToast.toast(msg, { variant: 'warning' })
        }
      } catch (e) {
        console.error('descargarExcel paquetes prev', e?.response?.data || e)
        this.$bvToast && this.$bvToast.toast('Ocurrió un error al descargar.', { variant: 'danger' })
      } finally {
        this.descargandoBase = false
      }
    },
    async getDataTable(){
      this.loadingTable = true
      try{
        const tipoMap = { BASICO: '1', INTERMEDIO: '2', FULL: '3' }
        const estadoMap = { ACTIVO: '1', INACTIVO: '0' }
        const params = {
          search: this.filters.search || '',
          estado: '1',
          estadoActivo: estadoMap[this.filters.estado] || '',
          tipoPaquete: tipoMap[this.filters.tipoPaquete] || '',
          fechaDesde: this.filters.fechaDesde || null,
          fechaHasta: this.filters.fechaHasta || null,
          page: this.table.currentPage,
          pageSize: this.table.perPage,
        }

        const resp = await paquetesService.getAll(params)
        const rows = resp?.data || []
        const tipoShow = { '1':'Básico', '2':'Intermedio', '3':'Full' }
        const filtered = rows.filter(r => String(r.estado ?? '1') === '1')
        const mapped = filtered.map(r => {
          const json = this.parseJsonField(r.json_paquete)
          const precio = Number(json?.precio ?? NaN)
          const nombre = json?.nombre ?? ''
          const tipo = String(json?.tipoPaquete || '')
          const cad = json?.reglas?.caducidad || {}
          const vig = cad?.duracionEnabled && cad?.venceEn ? `Hasta ${cad.venceEn}` : 'Indefinida'
          const estActivo = String(r.estadoactivo) === '1'
          return {
            id: r.id,
            token: r.token,
            codigo: r.codigo,
            nombre,
            precio: Number.isFinite(precio) ? precio : null,
            tipoPaquete: tipo,
            vigencia: vig,
            fechaCreacion: this.formatDate(r.fecha_creacion),
            estado: estActivo ? 'Activo' : 'Inactivo',
            json_paquete: r.json_paquete,
          }
        })
        this.items = mapped
        this.table.totalRows = resp?.total || mapped.length
      } catch(e){
        console.error('getDataTable paquetes prev', e?.response?.data || e)
        this.items = []
        this.table.totalRows = 0
      } finally {
        this.loadingTable = false
      }
    },
    parseJsonField(v){
      if (!v) return {}
      if (typeof v === 'object') return v
      const s = String(v)
      // Primer intento: parse directo
      try { return JSON.parse(s) } catch (e) {}
      // Segundo intento: quitar comillas envolventes y des-escapar
      try {
        const trimmed = s.trim().replace(/^"+|"+$/g, '')
        const fixed = trimmed.replace(/\\"/g, '"').replace(/""/g, '"')
        return JSON.parse(fixed)
      } catch (e) {}
      return {}
    },
    tipoLabel(v){
      const show = { '1':'Básico', '2':'Intermedio', '3':'Full', BASICO:'Básico', INTERMEDIO:'Intermedio', FULL:'Full' }
      return show[String(v)] || ''
    },
    formatCurrency(v){
      const n = Number(v)
      if (!Number.isFinite(n)) return ''
      try{ return new Intl.NumberFormat('es-EC', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(n) }catch(e){ return `$${n.toFixed(2)}` }
    },
    formatDate(v){
      if (!v) return ''
      const d = new Date(v)
      if (isNaN(d)) return String(v)
      try{ return new Intl.DateTimeFormat('es-EC').format(d) }catch(e){ return d.toISOString().slice(0,10) }
    },
    abrirModalVer(item){
      const json = this.parseJsonField(item.json_paquete || item._json || null) || {}
      this.previewData = {
        nombre: json.nombre || '',
        precio: json.precio || null,
        portada_url: json.portada_url || '',
        descripcion: json.descripcion || '',
        reglas: json.reglas || {},
        servicios: json.servicios || {},
        notas: json.notas || '',
      }
      this.modalVer = true
    },
    editarPaquete(item){
      this.tokenEdit = item.token
      this.idEdit = item.id
      this.editJson = this.parseJsonField(item.json_paquete)
      this.modalEditar = true
    },
    async eliminarPaquete(item){
      const ok = await (this.$swal ? this.$swal.fire({
        title: 'Desea eliminar el paquete?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#3085d6',
      }).then(r => r.isConfirmed) : Promise.resolve(confirm('Desea eliminar el paquete?')))
      if (!ok) return
      try{
        await paquetesService.setEstado(item.id, '0')
        this.$bvToast && this.$bvToast.toast('Paquete eliminado.', { variant: 'success' })
        this.getDataTable()
      } catch (e) {
        console.error('eliminarPaquete', e?.response?.data || e)
        this.$bvToast && this.$bvToast.toast('No se pudo eliminar.', { variant: 'danger' })
      }
    },
    onSaved(){
      this.modalCrear = false
      this.modalEditar = false
      this.getDataTable()
    }
  }
}
</script>

<style scoped>
.codigo-col {
  width: 15ch;
  max-width: 15ch;
  white-space: nowrap;
}
.nombre-col {
  /* espacio amplio; se trunca si excede */
  max-width: 48ch;
}
.estado-col {
  width: 12ch;
  max-width: 12ch;
}
.truncate {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
